module.exports = __webpack_public_path__ + "media/images/flags/4x3/uzb-a1a8b587f69d4a71d6f7bfee171b12d5.svg";